import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapState } from 'vuex';

const defaultEl = {
  id: null,
  name: '',
  color_hex: '',
  company_id: '',
  department_id: '',
  division_id: '',
  user_id: [],
  sequence: ''
};

export default {
  name: 'TeamEdit',
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      color_hex: { required },
      company_id: { },
      department_id: { required },
      division_id: { },
      user_id: { },
      sequence: { }
    }
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-teams'
    },
    basePath: {
      type: String,
      default: ''
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['config']),
    companyOptions () {
      const visibleCompanies = this.$session.get('visible_companies').map(Number);
      const options = this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions(
          'user_companies',
          this.$i18n.locale,
          'disabled',
          '0'
        ).filter(
          el => (
            visibleCompanies.includes(parseInt(el.value))
          )
        )
      );
      options.unshift({ value: null, text: '' });

      return options;
    },
    departmentOptions () {
      const departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id']
      ).filter(
        el => (
          parseInt(this.editEl.company_id) == parseInt(el.company_id)
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(departments, 'sortText');
    },
    divisionOptions () {
      const divisions = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id', 'department_id']
      ).filter(
        el => (
          parseInt(this.editEl.company_id) == parseInt(el.company_id) &&
          (this.editEl.department_id === null || parseInt(this.editEl.department_id) == parseInt(el.department_id))
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(divisions, 'sortText');
    },
    userOptions () {
      const users = [];

      if (!this.editEl.department_id) {
        return users;
      }

      let path = this.basePath + '/available-users?department_id=' + this.editEl.department_id;

      if (this.editEl.id) {
        path += '&team_id=' + this.editEl.id;
      }

      if (this.editEl.division_id) {
        path += '&division_id=' + this.editEl.division_id;
      }

      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          for (const ele of response.data) {
            users.push({ value: parseInt(ele.id), text: ele.name + ' ' + ele.surname });
          }
          this.isLoading = false;
        }
      });

      return users;
    },
    baseTransParam () {
      return 'team';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        elData.user_id = [];
        for (const user of elData.users) {
          elData.user_id.push(parseInt(user.user_id));
        }

        elData.company_id = this.$store.getters.getParamFromConfig('company_departments', elData.department_id, 'company_id');

        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        defaultEl.color_hex = this.getRandomColor();
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        this.ApiRequest.request(this.basePath + '/save' + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    },
    getRandomColor () {
      const colors = [
        'e2ec62', 'd0eae7', 'fcdfcd', 'ffc2eb', 'aecf29', 'a7e9cc',
        'f9c0af', 'f868b6', '58b868', '85d3d0', 'ff776d', '9581fd',
        '94af2b', '63b4ad', 'f8a879', '6d92fd', 'b8dd63', '2cced2',
        'fb6b8b', '3498f3'
      ];
      const idx = Math.floor(Math.random() * colors.length);
      return '#' + colors[idx];
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
